import vesennie_grezy from './vesennie_grezy';
import dve_velikie_istorii_o_lubvi from './dve_velikie_istorii_o_lubvi';
import devushka_is_chichen from './devushka_is_chichen';
import dul_veter_s_morya from './dul_veter_s_morya';
import iz_zhizni_biomusora from './iz_zhizni_biomusora';
import zachem_nam_mnozhestvennost_polov from './zachem_nam_mnozhestvennost_polov';
import nechto_o_lubvi from './nechto_o_lubvi';
import odinokiy from './odinokiy';
import o_drugoy_zhizni from './o_drugoy_zhizni';
import opyt_N3824 from './opyt_N3824';
import petlya_evolucii from './petlya_evolucii';
import po_krugu from './po_krugu';
import pochemu_u_yaguara from './pochemu_u_yaguara';
import prekrasnaya_roza from './prekrasnaya_roza';
import svoboda from './svoboda';
import tuda_ili_nazad from './tuda_ili_nazad';
import epizod_iz_zhizni_zemli from './epizod_iz_zhizni_zemli';
import proklyatie_starosti from './proklyatie_starosti';
import kogda_hmurym_utrom from './kogda_hmurym_utrom';
import iz_doneseniy_pilota from './iz_doneseniy_pilota';
import secretnaja_zjizn_v_gorode from './secretnaja_zjizn_v_gorode';
import detskie_shalosti from './detskie_shalosti';
import otryvok_is_raporta_pilota from './otryvok_is_raporta_pilota';
import stupeni_poznanija from './stupeni_poznanija';
import ubiystvo_mnemoziny from './ubiystvo_mnemoziny';
import opyty_in_vitro from './opyty_in_vitro';
import za_demokratiyu from './za_demokratiyu';
import okonchatelnaya_pobeda from './okonchatelnaya_pobeda';
import rozjdestv_rasskaz from './rozjdestv_rasskaz';
import kak_dve_odessitki_aziatskiy_kongres from './kak_dve_odessitki_aziatskiy_kongres';
import o_kosmicheskom_rae from './o_kosmicheskom_rae';
import zametka_is_nauch_pop_zhurnala from './zametka_is_nauch_pop_zhurnala';
import schastlivogo_puti from './schastlivogo_puti';
import otryvok_iz_intervyu from './otryvok_iz_intervyu';
import umirajushiy_lebed from './umirajushiy_lebed';
import telo_dernulos from './telo_dernulos';

const list = [
  vesennie_grezy,
  dve_velikie_istorii_o_lubvi,
  devushka_is_chichen,
  dul_veter_s_morya,
  iz_zhizni_biomusora,
  zachem_nam_mnozhestvennost_polov,
  nechto_o_lubvi,
  odinokiy,
  o_drugoy_zhizni,
  opyt_N3824,
  petlya_evolucii,
  po_krugu,
  pochemu_u_yaguara,
  prekrasnaya_roza,
  svoboda,
  tuda_ili_nazad,
  epizod_iz_zhizni_zemli,
  proklyatie_starosti,
  kogda_hmurym_utrom,
  iz_doneseniy_pilota,
  secretnaja_zjizn_v_gorode,
  detskie_shalosti,
  otryvok_is_raporta_pilota,
  stupeni_poznanija,
  ubiystvo_mnemoziny,
  opyty_in_vitro,
  za_demokratiyu,
  okonchatelnaya_pobeda,
  rozjdestv_rasskaz,
  kak_dve_odessitki_aziatskiy_kongres,
  o_kosmicheskom_rae,
  zametka_is_nauch_pop_zhurnala,
  schastlivogo_puti,
  otryvok_iz_intervyu,
  umirajushiy_lebed,
  telo_dernulos
];

export default list;